import React, { useCallback, useEffect, useState } from "react";
import {
  LocationMarkerIcon,
  CalendarIcon,
  ClockIcon,
  UsersIcon,
  CashIcon,
} from "@heroicons/react/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputField from "./InputField";
import googleplay from "../../assets/gplay-logo.png";
import "animate.css";
import AutoCompletePlaceItem from "../b2c/AutoCompletePlaceItem";
import { useDispatch, useSelector } from "react-redux";
import GoogleIcon from "../../assets/icons/google.png";
import { useNavigate } from "react-router-dom";
// import google icon from fontawesome
import TimePicker from "../../utils/TimePicker/TimePicker";
import {
  changeDestinationInput,
  changeSourceInput,
  clearDestinationInput,
  clearSourceInput,
  setDestinationInput,
  setSourceInput,
} from "../../redux/app/map/map-slice";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import BackgroundChauffer from "./../../assets/background_chauffer.png";
import {
  clearCurrency,
  clearPassenger,
  getDistanceInKm,
  getLatLanOfDestination,
  getLatLanOfSource,
  selectPassenger,
  setBookingDateChange,
  setBookingDetails,
  setCurrency,
} from "../../redux/app/booking/booking-slice";
// import moment timezone
import momenttz from "moment-timezone";
import {
  getVehicles,
  getVehiclesErr,
} from "../../redux/app/vehicle/vehicle-slice";
import DatePicker from "react-date-picker";
import { toast } from "react-toastify";
import {
  faCalendar,
  faClock,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import LoadingIcon from "../loading/LoadingIcon";
import banner from "../../assets/images/Website Banner-01.png";

let vehicleCurrency = {};
const BodyIntro = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const { settings } = useSelector((state) => state.settings);
  const [formSwitchOneWay, setformSwitchOneWay] = useState(true);
  const {
    sourceInputFromApi,
    sourceInput,
    destinationInput,
    destinationInputFromApi,
    placesbygoogle,
    placesbygoogleForDestination,
  } = useSelector((state) => state.map);
  const [openTimePicker, setOpenTimePicker] = useState(false);
  const {
    selectedPassenger,
    timeDetails,
    selectdCurrency,
    sourceLatLan,
    destinationLatLan,
    distanceInKm,
    distance,
    isSearhingCar,
    sourceWithRegion,
    destinationWithRegion,
    checkSourceRegion,
    checkDestinationRegion,
  } = useSelector((state) => state.booking);
  const { companyDetails } = useSelector((state) => state.company);

  const { vehicles, err } = useSelector((state) => state.vehicle);

  const [dateChange, setDateChange] = useState(undefined);
  const [timeChange, setTimeChange] = useState("10:00");
  const [tzUpdate, setTzUpdate] = useState(undefined);
  const [hourlyTime, sethourlyTime] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [searchLoading, setsearchLoading] = useState(false);

  // source region input

  // let time = momenttz
  //   .tz(
  let time = dateChange + " " + timeChange; // timeDetails.timezone_location

  // )
  // .format("YYYY-MM-DD HH:mm:ss");

  useEffect(() => {
    dispatch(
      getLatLanOfSource({
        sourceLatLan: "",
      })
    );
    dispatch(
      getLatLanOfDestination({
        destinationLatLan: "",
      })
    );
  }, []);

  useEffect(() => {
    let t = moment(time).format("YYYY-MM-DD HH:mm ");
    setTzUpdate(t);
  }, [timeDetails.timezone, time]);

  useEffect(() => {
    if (sourceLatLan && destinationLatLan) {
      dispatch({
        type: "GET_DISTANCE_BETWEEN_SOURCE_AND_DESTINATION",
        payload: {
          sourcelatlng: sourceLatLan,
          destlatlng: destinationLatLan,
        },
      });
    }
  }, [sourceLatLan, destinationLatLan, dispatch]);

  useEffect(() => {
    if (checkDestinationRegion && checkSourceRegion && dateChange && distance) {
      // dispatch({
      //   type: "SEARCH_INITIATE",
      // });
      dispatch({
        type: "GET_VEHICLES_WITH_PRICE",
        payload: {
          date: dateChange,
          km: distance,
          userId: "b2c",
          time: timeValue,
          sourceLatLng: sourceLatLan,
          destinationLatLng: destinationLatLan,
          currency: selectdCurrency,
        },
      });
    }
  }, [
    checkDestinationRegion,
    checkSourceRegion,
    distance,
    dateChange,
    dispatch,
    selectdCurrency,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (checkSourceRegion && hourlyTime && dateChange) {
        dispatch({
          type: "GET_VEHICLES_WITH_PRICE_HOURLY",
          payload: {
            sourceplaceid: sourcePlaceId,
            hour: hourlyTime?.hour,
            distance: hourlyTime?.distance,
            date: dateChange,
            currency: selectdCurrency,
          },
        });
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [checkSourceRegion, hourlyTime, dateChange, dispatch, selectdCurrency]);

  const [openDatePicker, setopenDatePicker] = useState(false);
  const [openPassengerSelect, setopenPassengerSelect] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);

  // const wrapperRef = useRef("");
  // outsideClick(wrapperRef, () => {
  //   setOpenCurrency(false);
  // });
  useEffect(() => {
    if (!localStorage.getItem("newbookingreloadb2c")) {
      localStorage.setItem("newbookingreloadb2c", "true");
      window.location.reload();
    }
  }, []);

  let passenger = [];
  for (let i = 0; i < 6; i++) {
    passenger.push(i + 1);
  }

  let Currency = [
    "USD",
    "INR",
    "EUR",
    "GBP",
    "AUD",
    "CAD",
    "SGD",
    "JPY",
    "AED",
    "CNY",
    "KWD",
    "NZD",
    "QAR",
    "SAR",
    "SGD",
    "OMR",
  ];

  const duration = [
    {
      hour: 1,
      distance: 20,
    },
    {
      hour: 2,
      distance: 40,
    },
    {
      hour: 3,
      distance: 60,
    },
    {
      hour: 4,
      distance: 80,
    },
    {
      hour: 5,
      distance: 100,
    },
    {
      hour: 6,
      distance: 120,
    },
    {
      hour: 7,
      distance: 140,
    },
    {
      hour: 8,
      distance: 160,
    },
    {
      hour: 9,
      distance: 180,
    },
    {
      hour: 10,
      distance: 200,
    },
    {
      hour: 11,
      distance: 220,
    },
    {
      hour: 12,
      distance: 240,
    },
    {
      hour: 13,
      distance: 260,
    },
    {
      hour: 14,
      distance: 280,
    },
    {
      hour: 15,
      distance: 300,
    },
    {
      hour: 16,
      distance: 320,
    },
    {
      hour: 17,
      distance: 340,
    },
    {
      hour: 18,
      distance: 360,
    },
    {
      hour: 19,
      distance: 380,
    },
    {
      hour: 20,
      distance: 400,
    },
    {
      hour: 21,
      distance: 420,
    },
    {
      hour: 22,
      distance: 440,
    },
    {
      hour: 23,
      distance: 460,
    },
    {
      hour: 24,
      distance: 480,
    },
  ];

  const [openHour, setOpenHour] = useState(false);

  let travelTimeInSeconds = new Date(tzUpdate).getTime() / 1000;
  let currentTimeInSeconds = new Date(timeDetails.date_time).getTime() / 1000;
  let timeDiffInSeconds = Math.abs(travelTimeInSeconds - currentTimeInSeconds);

  const [isTimeChange, setisTimeChange] = useState(false);
  const [dateValue, setDateValue] = useState();
  const [timeValue, setTimeValue] = useState("10:01");

  // handlers
  const handleTimeChange = useCallback(
    (timeValue) => {
      setisTimeChange(true);

      setTimeValue(timeValue);
      setTimeChange(timeValue);
    },
    [dispatch, sourceInputFromApi]
  );

  const [sourceRegionInput, setsourceRegionInput] = useState("");
  const [destinationRegionInput, setdestinationRegionInput] = useState("");
  const [sourceSuggestionOpen, setSourceSuggestionOpen] = useState(false);
  const [destinationSuggestionOpen, setDestinationSuggestionOpen] =
    useState(false);
  const [sourcePlaceId, setsourcePlaceId] = useState();
  const [destinationPlaceId, setdestinationPlaceId] = useState();
  const [sourcePlace, setsourcePlace] = useState();
  const [destinationPlace, setdestinationPlace] = useState();

  useEffect(() => {
    const getPlacesFromGoogleData = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeSourceInput({
          sourceInput: sourceRegionInput,
        })
      );
      if (sourceRegionInput?.length > 2 && sourceSuggestionOpen) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE",
          payload: sourceRegionInput,
        });
      }
    }, 200);
    return () => clearTimeout(getPlacesFromGoogleData);
  }, [sourceRegionInput, sourceSuggestionOpen]);

  useEffect(() => {
    if (sourcePlaceId) {
      dispatch(
        getDistanceInKm({
          distance: undefined,
        })
      );
      dispatch({
        type: "MATCHING_REGION_SOURCE",
        payload: {
          sourcePLaceId: sourcePlaceId,
        },
      });
    }
  }, [sourcePlaceId, dispatch]);

  // when currency is changed

  useEffect(() => {
    if (destinationPlaceId) {
      dispatch(
        getDistanceInKm({
          distance: undefined,
        })
      );
      dispatch({
        type: "MATCHING_REGION_DESTINATION",
        payload: {
          destPLaceId: destinationPlaceId,
        },
      });
    }
  }, [destinationPlaceId, dispatch]);

  useEffect(() => {
    const getPlacesFromGoogleDataDestination = setTimeout(() => {
      dispatch(
        getVehicles({
          vehicle: undefined,
        })
      );
      dispatch(
        getVehiclesErr({
          vehicle: undefined,
        })
      );
      dispatch(
        changeDestinationInput({
          destinationInput: destinationRegionInput,
        })
      );
      if (destinationRegionInput?.length > 2 && destinationSuggestionOpen) {
        dispatch({
          type: "GET_PLACES_FROM_GOOGLE_FOR_DEST",
          payload: destinationRegionInput,
        });
      }
    }, 200);
    return () => clearTimeout(getPlacesFromGoogleDataDestination);
  }, [destinationRegionInput, destinationSuggestionOpen]);

  useEffect(() => {
    if (timeDetails?.timezone && !isTimeChange) {
      let timezonevalue = momenttz
        .tz(timeDetails.date_time, timeDetails?.timezone)
        .format("HH:mm");

      // setTimeValue(timezone.toString());
      setTimeValue(timezonevalue);
      setTimeChange(timezonevalue);
    }
  }, [timeDetails?.timezone, timeDetails?.date_time, isTimeChange]);

  // removing distance value
  useEffect(() => {
    dispatch(
      getDistanceInKm({
        distance: undefined,
      })
    );
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    if (
      sourceInput === undefined ||
      tzUpdate === undefined ||
      dateChange === undefined
    ) {
      toast.warning("Please fill all the fields", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
      });
    } else {
      setsearchLoading(true);

      const payload = {
        source: {
          placename: sourcePlace?.description,
          placeid: sourcePlace?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        destination: {
          placename: destinationPlace?.description,
          placeid: destinationPlace?.place_id,
          lat: destinationLatLan.split(",")[0],
          lng: destinationLatLan.split(",")[1],
        },
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
      };

      const hourlyPayload = {
        source: {
          placename: sourcePlace?.description,
          placeid: sourcePlace?.place_id,
          lat: sourceLatLan.split(",")[0],
          lng: sourceLatLan.split(",")[1],
        },
        duration: hourlyTime?.hour,
        travelDistance: hourlyTime?.distance,
        travelDate: dateChange,
        travelTime: tzUpdate,
        passenger: selectedPassenger,
        bookingType: formSwitchOneWay ? "ONEWAY" : "HOURLY",
      };

      dispatch(
        setBookingDetails({
          booking: formSwitchOneWay ? payload : hourlyPayload,
        })
      );

      if (formSwitchOneWay) {
        dispatch({
          type: "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE",
          payload: {
            navigate,
            distanceInKm: distanceInKm?.km,
            source: {
              lat: sourceLatLan.split(",")[0],
              lng: sourceLatLan.split(",")[1],
            },
            sourceLatLan,
            destinationLatLan,
            destination: {
              lat: destinationLatLan.split(",")[0],
              lng: destinationLatLan.split(",")[1],
            },
          },
        });
      } else {
        dispatch({
          type: "GET_MATCHING_REGIONS_AND_SEARCH_VEHICLE_HOURLY",
          payload: {
            navigate,
          },
        });
      }
    }
  };

  // find locations when key stoke is there for source input

  const onChange = (timeValue) => {
    setTimeValue(timeValue);
  };

  useEffect(() => {
    if (distance && vehicles !== undefined && isSubmit) {
      navigate("/searchResult");
      setIsSubmit(false);
      setsearchLoading(false);
    }
    if (err) {
      toast.warning(err, {
        position: "top-center",
        autoClose: 9000,
        hideProgressBar: false,
      });
      setsearchLoading(false);
    }
  }, [dispatch, distance, vehicles, isSubmit, navigate, err]);

  return (
    <div>
      <div className="relative">
        <img
          // src={require("../../assets/drivado_homme_banner.png")}
          src={banner}
          alt=""
          className="hidden sm:block sm:h-[38rem] md:h-[36rem] lg:h-[38rem] xl:h-[39rem] 2xl:h-[43rem] lg:w-screen md:w-full md:flex md:mx-auto md:object-cover sm:object-fill object-cover"
        />

        {/* <div className="bg-gradient-to-r from-[#121518] to-[#000000] h-[500px] w-full sm:h-full opacity-0 absolute top-0"></div> */}

        {/* 📱---------------------------📱 MOBILE VIEW START 📱----------------------------- 📱 */}

        {/* header contents */}
        <div className="absolute transform -translate-x-1/2 lg:hidden top-5 md:top-3 left-1/2">
          {/* tagline text */}
          <div className="mb-2 hidden">
            <div className="flex justify-center space-x-2">
              <div className="font-semibold text-white tagLine">
                Driving&nbsp;you
              </div>
              <div className="text-secondary tagLine animate__animated animate__lightSpeedInRight">
                {" "}
                anywhere,
              </div>
            </div>
            <div className="text-center text-secondary tagLine animate__animated animate__lightSpeedInRight">
              anytime
            </div>
          </div>

          {/* form bakground color */}
          <div className="sm:bg-[#150800] h-[26.5rem] sm:h-[27rem] md:h-[26rem] w-[20rem] md:w-[28.1rem] sm:w-[22rem] rounded-sm shadow-lg shadow-gray-600 mt-14 md:mt-20 sm:mt-16"></div>

          {/* form */}
          <div className="h-full opacity-80 w-full absolute top-10 sm:top-[5.5rem] px-5 transform translate-y-6 sm:-translate-y-2 md:-pt-36">
            <div className="flex space-x-0 mb-0 px-0">
              <button
                onClick={() => {
                  setformSwitchOneWay(true);
                  setsourcePlaceId("");
                  dispatch(
                    getLatLanOfSource({
                      sourceLatLan: "",
                    })
                  );
                  dispatch(
                    getLatLanOfDestination({
                      destinationLatLan: "",
                    })
                  );
                  dispatch(
                    getVehicles({
                      vehicles: undefined,
                    })
                  );
                  setsourceRegionInput("");
                  setdestinationRegionInput("");
                }}
                className={`${
                  formSwitchOneWay
                    ? "sm:opacity-90 text-secondary"
                    : "sm:opacity-50 text-white"
                } bg-[#150800]  font-normal w-full text-sm py-3 rounded-[2px]`}
              >
                ONEWAY
              </button>
              <button
                onClick={() => {
                  setformSwitchOneWay(false);
                  setsourcePlaceId("");

                  dispatch(
                    getLatLanOfSource({
                      sourceLatLan: "",
                    })
                  );
                  dispatch(
                    getLatLanOfDestination({
                      destinationLatLan: "",
                    })
                  );
                  dispatch(
                    getVehicles({
                      vehicles: undefined,
                    })
                  );
                  setsourceRegionInput("");
                  setdestinationRegionInput("");
                }}
                className={`${
                  !formSwitchOneWay
                    ? "sm:opacity-90 text-secondary"
                    : "sm:opacity-50 text-white"
                } bg-[#150800] w-full text-sm font-normal py-3 rounded-[2px]`}
              >
                HOURLY
              </button>
            </div>

            <form action="" className="space-y-2">
              {/* source input */}
              <InputField
                placeholder="Address, Hotel, Airport"
                Icon={LocationMarkerIcon}
                label="From"
                type="text"
                value={sourceRegionInput}
                onChange={(e) => {
                  dispatch(
                    getLatLanOfSource({
                      sourceLatLan: "",
                    })
                  );
                  setsourcePlaceId("");
                  setsourceRegionInput(e.target.value);
                  setSourceSuggestionOpen(true);
                }}
                onClick={() => {
                  setOpenTimePicker(false);
                  setOpenCurrency(false);
                  setopenPassengerSelect(false);
                  setOpenHour(false);
                  setDestinationSuggestionOpen(false);
                }}
              />
              {placesbygoogle.length > 0 && sourceSuggestionOpen && (
                <>
                  <div className="absolute w-full font-body bg-white shadow-2xl h-72 scrollbar rounded-bl-md rounded-br-md z-10">
                    <div className="overflow-y-auto">
                      {placesbygoogle?.map((place) => (
                        <>
                          <AutoCompletePlaceItem
                            onClick={() => {
                              let selectedPlace =
                                place?.terms[0]?.value +
                                " " +
                                place?.terms[1]?.value +
                                " " +
                                place?.terms[2]?.value;
                              setsourcePlace(place);
                              setsourceRegionInput("");
                              setsourceRegionInput(selectedPlace);
                              // and the same time finding lat an  lng to store to db and to get distance
                              dispatch({
                                type: "GET_LAT_LAN_OF_SOURCE",
                                payload: place.place_id,
                              });
                              setsourcePlaceId(place.place_id);
                              setSourceSuggestionOpen(false);
                            }}
                            key={place?.place_id}
                            placeTerms={place?.terms}
                          />
                        </>
                      ))}
                    </div>
                    <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                      <div className="text-sm font-semibold text-gray-400 ">
                        Powered By{" "}
                      </div>
                      <div>
                        <img
                          src={GoogleIcon}
                          alt="google icon"
                          className="w-5 h-5"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {/* source input end */}
              {formSwitchOneWay ? (
                <>
                  {/* destination input start */}
                  <InputField
                    placeholder="Address, Hotel, Airport"
                    Icon={LocationMarkerIcon}
                    label="To"
                    type="text"
                    value={destinationRegionInput}
                    onChange={(e) => {
                      dispatch(
                        getLatLanOfDestination({
                          destinationLatLan: "",
                        })
                      );
                      setdestinationPlaceId("");
                      setdestinationRegionInput(e.target.value);
                      setDestinationSuggestionOpen(true);
                    }}
                    onClickClear={() => {
                      dispatch(clearDestinationInput());
                    }}
                    onClick={() => {
                      setOpenTimePicker(false);
                      setOpenCurrency(false);
                      setopenPassengerSelect(false);
                      setOpenHour(false);
                      setSourceSuggestionOpen(false);
                    }}
                  />
                  {placesbygoogleForDestination.length > 0 &&
                    destinationSuggestionOpen && (
                      <>
                        <div className="absolute w-full font-body bg-white shadow-2xl h-72 scrollbar rounded-bl-md rounded-br-md z-10">
                          <div className="overflow-y-auto">
                            {placesbygoogleForDestination?.map((place) => (
                              <>
                                <AutoCompletePlaceItem
                                  onClick={() => {
                                    let selectedPlace =
                                      place?.terms[0]?.value +
                                      " " +
                                      place?.terms[1]?.value +
                                      " " +
                                      place?.terms[2]?.value;
                                    setdestinationPlace(place);
                                    setdestinationRegionInput("");
                                    setdestinationRegionInput(selectedPlace);

                                    dispatch({
                                      type: "GET_LAT_LAN_OF_DESTINATION",
                                      payload: place.place_id,
                                    });
                                    setdestinationPlaceId(place.place_id);
                                    setDestinationSuggestionOpen(false);
                                  }}
                                  key={place?.place_id}
                                  placeTerms={place?.terms}
                                />
                              </>
                            ))}
                          </div>
                          <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                            <div className="text-sm font-semibold text-gray-400 ">
                              Powered By{" "}
                            </div>
                            <div>
                              <img
                                src={GoogleIcon}
                                alt="google icon"
                                className="w-5 h-5"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  {/* destination input end */}
                </>
              ) : (
                <>
                  <InputField
                    placeholder="1 hour (20 Km)"
                    Icon={ClockIcon}
                    label="Duration"
                    value={
                      hourlyTime
                        ? hourlyTime?.hour +
                          " hour (" +
                          hourlyTime?.distance +
                          " Km)"
                        : ""
                    }
                    onClick={() => {
                      setOpenHour(true);
                      setOpenCurrency(false);
                      setopenPassengerSelect(false);
                      setSourceSuggestionOpen(false);
                      setDestinationSuggestionOpen(false);
                      setOpenTimePicker(false);
                    }}
                  />

                  {openHour && (
                    <>
                      <div className="bg-black w-full "></div>
                      <div className="absolute z-30 w-full font-body bg-[f1f5f9] shadow-2xl h-20 scrollbar rounded-bl-md rounded-br-md">
                        <div className="overflow-y-auto h-72 scrollbar">
                          {duration.map((dur) => (
                            <div
                              key={dur.hour}
                              onClick={() => {
                                sethourlyTime(dur);
                                // dispatch(
                                //   setCurrency({
                                //     selectdCurrency: c,
                                //   })
                                // );
                                setOpenHour(false);
                              }}
                              className="flex items-center px-2 py-1 space-x-3 cursor-pointer bg-slate-100 hover:bg-secondary hover:text-white"
                            >
                              <div className="flex space-x-2 ">
                                <span>{dur.hour} </span>
                                <span>{dur.hour > 1 ? "hours" : "hour"}</span>
                                <span>({dur.distance} kms)</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
              <div>
                <div className="w-full grow flex bg-white px-3 py-0.5 rounded-lg items-center">
                  <FontAwesomeIcon
                    icon={faCalendar}
                    className="h-4 w-5 mr-3 text-primary"
                  />
                  <div className="w-[100%]">
                    <div className="font-body text-sm font-semibold text-gray-500">
                      Date
                    </div>

                    <DatePicker
                      className="h-5 border-none flex"
                      icon={UsersIcon}
                      format="dd-MM-y"
                      // minDate={new Date('06/02/2023')}
                      // maxDate={new Date('10/02/2023')}
                      dayPlaceholder="DD"
                      monthPlaceholder="MM"
                      yearPlaceholder="YYYY"
                      minDate={new Date()}
                      // minDate={new Date(moment().subtract(1,"day"))}
                      // placeHolder="dd-mm-yy"
                      onChange={(e) => {
                        setDateValue(e);
                        setDateChange(moment(e).format("yyyy-MM-DD"));
                        dispatch(
                          setBookingDateChange({
                            dateChange: moment(e).format("yyyy-MM-DD"),
                          })
                        );
                      }}
                      onClick={() => {
                        setOpenCurrency(false);
                        setopenPassengerSelect(false);
                        setSourceSuggestionOpen(false);
                        setDestinationSuggestionOpen(false);
                        setOpenTimePicker(false);
                        setOpenHour(false);
                      }}
                      //                 popperPlacement="bottom"
                      // popperModifiers={[
                      //   {
                      //     name: "flip",
                      //     options: {
                      //       fallbackPlacements: ["bottom"],
                      //       allowedAutoPlacements: ["bottom"],
                      //     },
                      //   },
                      // ]}
                      value={dateValue}
                    />
                  </div>
                </div>
                <div className="">
                  {Math.floor(timeDiffInSeconds / 3600) <
                    settings.bookingTimeFrame && (
                    <>
                      <div className="absolute transform -translate-x-[400px] bg-white animate p-3 rounded-md text-primary font-semibold">
                        <span>
                          Time must be at least {settings.bookingTimeFrame}{" "}
                          hours from pick up time
                        </span>
                      </div>
                    </>
                  )}
                  <div className="mt-2">
                    <div className="w-full grow flex  font-serif bg-white px-3 py-0.5 space-x-2 rounded-lg items-center lg:px-2 lg:py-[3px] lg:w-full lg:h-full border-none">
                      <FontAwesomeIcon
                        icon={faClock}
                        className="h-4 w-5 mr-0 text-primary"
                      />
                      <div className="w-[100%">
                        <div className="font-body text-sm font-semibold text-gray-500">
                          Time
                        </div>
                        <div className="w-24 h-5 border-none relative">
                          {openTimePicker && (
                            <div className="absolute translate-y-5 ">
                              <div className=" animate__animated animate__fadeIn">
                                <TimePicker
                                  onHandleTimeChange={handleTimeChange}
                                  onClickClose={() => {
                                    setOpenTimePicker(false);
                                  }}
                                  timeValue={timeValue}
                                />
                              </div>
                            </div>
                          )}
                          <div
                            className="w-full cursor-pointer"
                            onClick={() => {
                              setOpenTimePicker(true);
                              setOpenCurrency(false);
                              setopenPassengerSelect(false);
                              setSourceSuggestionOpen(false);
                              setDestinationSuggestionOpen(false);
                              setOpenHour(false);
                              setopenDatePicker(false);
                            }}
                          >
                            {timeValue}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <InputField
                Icon={UsersIcon}
                placeholder="Select passenger"
                label="Passenger"
                value={selectedPassenger}
                onClickClear={() => {
                  dispatch(clearPassenger());
                }}
                onChange={() => {}}
                onClick={() => {
                  setopenPassengerSelect(true);
                  setOpenCurrency(false);
                  setSourceSuggestionOpen(false);
                  setDestinationSuggestionOpen(false);
                  setOpenTimePicker(false);
                  setOpenHour(false);
                  setopenDatePicker(false);
                }}
              />

              {/* passenger dropdown start */}
              {openPassengerSelect && (
                <>
                  <div className="absolute w-full bg-slate-100 shadow-2xl h-60 scrollbar rounded-bl-md rounded-br-md z-10">
                    <div className="overflow-y-auto">
                      {passenger.map((passenger) => (
                        <>
                          <div
                            key={passenger}
                            onClick={() => {
                              dispatch(
                                selectPassenger({
                                  selectedPassenger:
                                    passenger +
                                    ` ${
                                      passenger > 1 ? "Passengers" : "Passenger"
                                    } `,
                                })
                              );
                              setopenPassengerSelect(false);
                            }}
                            className="flex items-center px-3 py-2 space-x-2 text-base font-medium cursor-pointer hover:bg-secondary hover:text-white last:hover:rounded-bl-md last:hover:rounded-br-md"
                          >
                            <span>{passenger}</span>
                            <span>
                              {passenger > 1 ? "Passengers" : "Passenger"}
                            </span>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </>
              )}

              <InputField
                Icon={CashIcon}
                placeholder="Select Currency"
                label="Currency"
                value={selectdCurrency}
                onClickClear={() => {
                  dispatch(clearCurrency());
                }}
                onChange={() => {}}
                onClick={() => {
                  setOpenCurrency(true);
                  setopenPassengerSelect(false);
                  setSourceSuggestionOpen(false);
                  setDestinationSuggestionOpen(false);
                  setOpenTimePicker(false);
                  setOpenHour(false);
                  setopenDatePicker(false);
                }}
              />
              {openCurrency && (
                <>
                  <div className="absolute w-full bg-slate-100 shadow-2xl h-60 scrollbar rounded-bl-md rounded-br-md">
                    <div className="overflow-y-auto scrollbar max-h-60">
                      {Currency.map((c, index) => (
                        <>
                          <div
                            key={index}
                            onClick={() => {
                              dispatch(
                                setCurrency({
                                  selectdCurrency: c,
                                })
                              );
                              setOpenCurrency(false);
                            }}
                            className="flex items-center px-3 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                          >
                            <span>{c}</span>
                          </div>
                        </>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {/* passenger dropdown end */}
              {!(Math.floor(timeDiffInSeconds / 3600) < 24) && (
                <button
                  onClick={handleSubmit}
                  className={` text-white bg-gradient-to-t from-[#a72231] to-[#fb4156]  ${
                    isSearhingCar && "cursor-not-allowed"
                  }  hover:bg-gradient-to-t hover:from-[#b92f3f] hover:to-[#fb4156] w-full mx-auto justify-center mt-10 flex font-semibold text-mb  py-2 rounded-sm`}
                >
                  {!searchLoading ? (
                    "BOOK A RIDE"
                  ) : (
                    <>
                      <div className="flex items-center justify-center space-x-2 test-white">
                        <div>Searching cars</div>
                        <LoadingIcon />
                      </div>
                    </>
                  )}
                </button>
              )}
            </form>
          </div>
        </div>

        {/* 🌐-------------------------------🌐 WEB VIEW START 🌐------------------------------ 🌐 */}
        <div className="hidden lg:block absolute w-full xl:px-40 2xl:px-56 bottom-0 sm:py-10  ">
          <div className="2xl:items-start justify-between items-center lg:px-16 xl:px-0 mt-5 pb-52 ">
            <div className="">
              <h2 className="font-body text-white text-xl lg:text-[1.25rem] xl:text-2xl">
                Seamless
              </h2>
              <h2 className="font-body text-white text-2xl lg:text-[1.3rem] xl:text-[1.5rem] 2xl:text-[2rem] font-semibold mt-2 lg:mt-1">
                Ground Transportation Worldwide
              </h2>
            </div>
            <div>
              {/* <div className="md:flex items-center space-x-4 lg:mt-5 xl:mt-5">
                <a href="#">
                  <img
                    src={require("../../assets/images/android_icon.png")}
                    alt=""
                    className="lg:w-32 xl:w-36 lg:h-10 xl:h-11 hover:opacity-90"
                  />
                </a>
                <a href="#">
                  <img
                    src={require("../../assets/images/ios_icon.png")}
                    alt=""
                    className="lg:w-32 xl:w-36 lg:h-10 xl:h-11 hover:opacity-90"
                  />
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div className="  absolute hidden transform lg:flex top-48 right-1/2 lg:top-52 xl:top-40 lg:translate-x-1/3 xl:translate-x-1/2 xl:mr-16 2xl:mr-0">
          {/* tagline text */}
          {/* <div className="transform -translate-x-1/3 lg:translate-x-36 xl:translate-x-6 2xl:-translate-x-1/4">
            <div className="flex space-x-2">
              <div className="font-body font-semibold text-white tagLine">
                Driving&nbsp;you
              </div>
              <div className="font-body text-secondary tagLine animate__animated animate__lightSpeedInRight">
                anywhere,
              </div>
            </div>
            <div className="font-body text-secondary tagLine animate__animated animate__lightSpeedInRight ">
              anytime
            </div>
            <div className="transform translate-y-48">
              <div className="font-sans text-xl font-semibold text-slate-200 ">
                <div className="font-body text-3xl">Download app</div>
                <div className="flex items-center pt-2 space-x-8 text-2xl text-center">                  
                  <div className="hover:-translate-y-0.25 transform  duration-700 transition  py-1 ">
                    <img
                      src={googleplay}
                      alt="google play"
                      className="w-10 h-10"
                    />                    
                  </div>
                  <div className="hover:-translate-y-0.25 transform duration-700 transition py-1 ">
                    <FontAwesomeIcon
                      icon="fa-brands fa-apple"
                      className="text-5xl cursor-pointer text-slate-300"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div></div>
          {/* form background */}
          <div className=" bg-white/20 backdrop-blur-md h-[460px] w-[520px] xl:mt-10 transform translate-x-[120px] lg:translate-x-[265px] xl:translate-x-[300px] -translate-y-16 lg:-translate-y-[5.5rem] xl:-translate-y-16 2xl:-translate-y-12 rounded-md  shadow-gray-100/25 shadow-sm "></div>

          {/* Form - input field with form */}
          <div className="relative">
            <div
              className="absolute w-full h-screen"
              onClick={() => {
                setopenPassengerSelect(false);
                setOpenCurrency(false);
                setSourceSuggestionOpen(false);
                setDestinationSuggestionOpen(false);
                setOpenHour(false);
                setOpenTimePicker(false);
              }}
            ></div>
            <div className="h-full opacity-100 w-96 pt-3 absolute transform -translate-y-64 xl:mt-10 md:-translate-y-[275px] lg:w-[498px] lg:h-[55px] lg:-translate-y-[5.7rem] xl:-translate-y-[4.2rem] 2xl:-translate-y-[3.2rem] lg:-translate-x-[15.3rem] xl:-translate-x-[13.1rem]">
              <div className="flex px-0 mb-0 space-x-0">
                <button
                  onClick={() => {
                    setformSwitchOneWay(true);
                  }}
                  className={`${
                    formSwitchOneWay
                      ? "text-white font-extrabold bg-black"
                      : "opacity-100 text-gray-300"
                  } w-full font-body bg-[#150800]/40 h-12  text-base font-normal py-0.5 rounded-[2px] hover:bg-[#150800] hover:opacity-100`}
                >
                  ONEWAY
                </button>
                <button
                  onClick={() => {
                    setformSwitchOneWay(false);
                  }}
                  className={`${
                    !formSwitchOneWay
                      ? " text-white font-extrabold bg-black"
                      : "opacity-100 text-gray-300"
                  } w-full font-body bg-[#150800]/40 h-12 text-base font-normal py-0.5 rounded-[2px] hover:bg-[#150800] hover:opacity-100`}
                >
                  HOURLY
                </button>
              </div>
              <form action="" className="space-y-2">
                {/* source input */}
                <InputField
                  placeholder="Address, Hotel, Airport"
                  Icon={LocationMarkerIcon}
                  label="From"
                  type="text"
                  value={sourceRegionInput}
                  onChange={(e) => {
                    dispatch(
                      getLatLanOfSource({
                        sourceLatLan: "",
                      })
                    );
                    setsourcePlaceId("");
                    setsourceRegionInput(e.target.value);
                    setSourceSuggestionOpen(true);
                  }}
                  onClick={() => {
                    setOpenTimePicker(false);
                    setOpenCurrency(false);
                    setopenPassengerSelect(false);
                    setOpenHour(false);
                    setDestinationSuggestionOpen(false);
                  }}
                />
                {placesbygoogle.length > 0 && sourceSuggestionOpen && (
                  <>
                    <div className="absolute w-full font-body bg-white shadow-2xl h-72 scrollbar rounded-bl-md rounded-br-md z-10">
                      <div className="overflow-y-auto">
                        {placesbygoogle?.map((place) => (
                          <>
                            <AutoCompletePlaceItem
                              onClick={() => {
                                let selectedPlace =
                                  place?.terms[0]?.value +
                                  " " +
                                  place?.terms[1]?.value +
                                  " " +
                                  place?.terms[2]?.value;
                                setsourcePlace(place);
                                setsourceRegionInput("");
                                setsourceRegionInput(selectedPlace);
                                // and the same time finding lat an  lng to store to db and to get distance
                                dispatch({
                                  type: "GET_LAT_LAN_OF_SOURCE",
                                  payload: place.place_id,
                                });
                                setsourcePlaceId(place.place_id);
                                setSourceSuggestionOpen(false);
                              }}
                              key={place?.place_id}
                              placeTerms={place?.terms}
                            />
                          </>
                        ))}
                      </div>
                      <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                        <div className="text-sm font-semibold text-gray-400 ">
                          Powered By{" "}
                        </div>
                        <div>
                          <img
                            src={GoogleIcon}
                            alt="google icon"
                            className="w-5 h-5"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* source input end */}
                {formSwitchOneWay ? (
                  <>
                    {/* destination input start */}
                    <InputField
                      placeholder="Address, Hotel, Airport"
                      Icon={LocationMarkerIcon}
                      label="To"
                      type="text"
                      value={destinationRegionInput}
                      onChange={(e) => {
                        dispatch(
                          getLatLanOfDestination({
                            destinationLatLan: "",
                          })
                        );
                        setdestinationPlaceId("");
                        setdestinationRegionInput(e.target.value);
                        setDestinationSuggestionOpen(true);
                      }}
                      onClickClear={() => {
                        dispatch(clearDestinationInput());
                      }}
                      onClick={() => {
                        setOpenTimePicker(false);
                        setOpenCurrency(false);
                        setopenPassengerSelect(false);
                        setOpenHour(false);
                        setSourceSuggestionOpen(false);
                      }}
                    />
                    {placesbygoogleForDestination.length > 0 &&
                      destinationSuggestionOpen && (
                        <>
                          <div className="absolute w-full font-body bg-white/5 shadow-2xl h-72 scrollbar rounded-bl-md rounded-br-md z-10">
                            <div className="overflow-y-auto">
                              {placesbygoogleForDestination?.map((place) => (
                                <>
                                  <AutoCompletePlaceItem
                                    onClick={() => {
                                      let selectedPlace =
                                        place?.terms[0]?.value +
                                        " " +
                                        place?.terms[1]?.value +
                                        " " +
                                        place?.terms[2]?.value;
                                      setdestinationPlace(place);
                                      setdestinationRegionInput("");
                                      setdestinationRegionInput(selectedPlace);

                                      dispatch({
                                        type: "GET_LAT_LAN_OF_DESTINATION",
                                        payload: place.place_id,
                                      });
                                      setdestinationPlaceId(place.place_id);
                                      setDestinationSuggestionOpen(false);
                                    }}
                                    key={place?.place_id}
                                    placeTerms={place?.terms}
                                  />
                                </>
                              ))}
                            </div>
                            <div className="static flex items-center justify-end mx-3 space-x-1 text-left ">
                              <div className="text-sm font-semibold text-gray-400 ">
                                Powered By{" "}
                              </div>
                              <div>
                                <img
                                  src={GoogleIcon}
                                  alt="google icon"
                                  className="w-5 h-5"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    {/* destination input end */}
                  </>
                ) : (
                  <>
                    <InputField
                      placeholder="1 hour (20 Km)"
                      Icon={ClockIcon}
                      label="Duration"
                      value={
                        hourlyTime
                          ? hourlyTime?.hour +
                            " hour (" +
                            hourlyTime?.distance +
                            " Km)"
                          : ""
                      }
                      onClick={() => {
                        setOpenHour(true);
                        setOpenCurrency(false);
                        setopenPassengerSelect(false);
                        setSourceSuggestionOpen(false);
                        setDestinationSuggestionOpen(false);
                        setOpenTimePicker(false);
                      }}
                    />

                    {openHour && (
                      <>
                        <div className="bg-black w-full "></div>
                        <div className="absolute z-30 w-full font-body bg-[f1f5f9] shadow-2xl h-20 scrollbar rounded-bl-md rounded-br-md">
                          <div className="overflow-y-auto h-72 scrollbar">
                            {duration.map((dur) => (
                              <div
                                key={dur.hour}
                                onClick={() => {
                                  sethourlyTime(dur);
                                  // dispatch(
                                  //   setCurrency({
                                  //     selectdCurrency: c,
                                  //   })
                                  // );
                                  setOpenHour(false);
                                }}
                                className="flex items-center px-2 py-1 space-x-3 cursor-pointer bg-slate-100 hover:bg-secondary hover:text-white"
                              >
                                <div className="flex space-x-2 ">
                                  <span>{dur.hour} </span>
                                  <span>{dur.hour > 1 ? "hours" : "hour"}</span>
                                  <span>({dur.distance} kms)</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
                <div>
                  <div className="w-full grow flex bg-white px-3 py-1 lg:py-[5px] rounded-lg items-center">
                    <FontAwesomeIcon
                      icon={faCalendar}
                      className="h-3 w-2 mr-2 lg:h-4 lg:w-10 lg:mr-3 text-primary"
                    />
                    <div className="w-[100%]">
                      <div className="font-body text-sm font-semibold text-gray-500">
                        Date
                      </div>

                      <DatePicker
                        className="h-5 border-none flex"
                        icon={UsersIcon}
                        format="dd-MM-y"
                        // minDate={new Date('06/02/2023')}
                        // maxDate={new Date('10/02/2023')}
                        dayPlaceholder="DD"
                        monthPlaceholder="MM"
                        yearPlaceholder="YYYY"
                        minDate={new Date()}
                        // minDate={new Date(moment().subtract(1,"day"))}
                        // placeHolder="dd-mm-yy"
                        onChange={(e) => {
                          setDateValue(e);
                          setDateChange(moment(e).format("yyyy-MM-DD"));
                          dispatch(
                            setBookingDateChange({
                              dateChange: moment(e).format("yyyy-MM-DD"),
                            })
                          );
                        }}
                        onClick={() => {
                          setOpenCurrency(false);
                          setopenPassengerSelect(false);
                          setSourceSuggestionOpen(false);
                          setDestinationSuggestionOpen(false);
                          setOpenTimePicker(false);
                          setOpenHour(false);
                        }}
                        //                 popperPlacement="bottom"
                        // popperModifiers={[
                        //   {
                        //     name: "flip",
                        //     options: {
                        //       fallbackPlacements: ["bottom"],
                        //       allowedAutoPlacements: ["bottom"],
                        //     },
                        //   },
                        // ]}
                        value={dateValue}
                      />
                    </div>
                  </div>
                  <div className="">
                    {Math.floor(timeDiffInSeconds / 3600) <
                      settings.bookingTimeFrame && (
                      <>
                        <div className="absolute transform -translate-x-[400px] bg-white animate p-3 rounded-md text-primary font-semibold">
                          <span>
                            Time must be at least {settings.bookingTimeFrame}{" "}
                            hours from pick up time
                          </span>
                        </div>
                      </>
                    )}
                    <div className="mt-2">
                      <div className="w-full grow flex  font-serif bg-white px-3 py-2 lg:py-[5px] space-x-2 h-60 rounded-lg items-center lg:px-2 lg:w-full lg:h-full border-none">
                        <FontAwesomeIcon
                          icon={faClock}
                          className="h-3 w-2 mr-2 lg:h-4 lg:w-10 lg:mr-0.5 text-primary"
                        />
                        <div className="w-[100%">
                          <div className="font-body text-sm font-semibold text-gray-500">
                            Time
                          </div>
                          <div className="w-24 h-5 border-none relative">
                            {openTimePicker && (
                              <div className="absolute translate-y-5 ">
                                <div className=" animate__animated animate__fadeIn">
                                  <TimePicker
                                    onHandleTimeChange={handleTimeChange}
                                    onClickClose={() => {
                                      setOpenTimePicker(false);
                                    }}
                                    timeValue={timeValue}
                                  />
                                </div>
                              </div>
                            )}
                            <div
                              className="w-full cursor-pointer"
                              onClick={() => {
                                setOpenTimePicker(true);
                                setOpenCurrency(false);
                                setopenPassengerSelect(false);
                                setSourceSuggestionOpen(false);
                                setDestinationSuggestionOpen(false);
                                setOpenHour(false);
                                setopenDatePicker(false);
                              }}
                            >
                              {timeValue}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <InputField
                  Icon={UsersIcon}
                  placeholder="Select passenger"
                  label="Passenger"
                  value={selectedPassenger}
                  onClickClear={() => {
                    dispatch(clearPassenger());
                  }}
                  onChange={() => {}}
                  onClick={() => {
                    setopenPassengerSelect(true);
                    setOpenCurrency(false);
                    setSourceSuggestionOpen(false);
                    setDestinationSuggestionOpen(false);
                    setOpenTimePicker(false);
                    setOpenHour(false);
                    setopenDatePicker(false);
                  }}
                />

                {/* passenger dropdown start */}
                {openPassengerSelect && (
                  <>
                    <div className="absolute w-full bg-slate-100 shadow-2xl h-60 scrollbar rounded-bl-md rounded-br-md z-10">
                      <div className="overflow-y-auto">
                        {passenger.map((passenger) => (
                          <>
                            <div
                              key={passenger}
                              onClick={() => {
                                dispatch(
                                  selectPassenger({
                                    selectedPassenger:
                                      passenger +
                                      ` ${
                                        passenger > 1
                                          ? "Passengers"
                                          : "Passenger"
                                      } `,
                                  })
                                );
                                setopenPassengerSelect(false);
                              }}
                              className="flex items-center px-3 py-2 space-x-2 text-base font-medium cursor-pointer hover:bg-secondary hover:text-white last:hover:rounded-bl-md last:hover:rounded-br-md"
                            >
                              <span>{passenger}</span>
                              <span>
                                {passenger > 1 ? "Passengers" : "Passenger"}
                              </span>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                )}

                <InputField
                  Icon={CashIcon}
                  placeholder="Select Currency"
                  label="Currency"
                  value={selectdCurrency}
                  onClickClear={() => {
                    dispatch(clearCurrency());
                  }}
                  onChange={() => {}}
                  onClick={() => {
                    setOpenCurrency(true);
                    setopenPassengerSelect(false);
                    setSourceSuggestionOpen(false);
                    setDestinationSuggestionOpen(false);
                    setOpenTimePicker(false);
                    setOpenHour(false);
                    setopenDatePicker(false);
                  }}
                />
                {openCurrency && (
                  <>
                    <div className="absolute w-full bg-slate-100 shadow-2xl h-60 scrollbar rounded-bl-md rounded-br-md">
                      <div className="overflow-y-auto scrollbar max-h-60">
                        {Currency.map((c, index) => (
                          <>
                            <div
                              key={index}
                              onClick={() => {
                                dispatch(
                                  setCurrency({
                                    selectdCurrency: c,
                                  })
                                );
                                setOpenCurrency(false);
                              }}
                              className="flex items-center px-3 py-2 space-x-2 text-[15px] font-normal cursor-pointer hover:bg-secondary hover:text-white"
                            >
                              <span>{c}</span>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {/* passenger dropdown end */}
                {!(Math.floor(timeDiffInSeconds / 3600) < 24) && (
                  <button
                    onClick={handleSubmit}
                    className={` text-white bg-gradient-to-t from-[#a72231] to-[#fb4156]  ${
                      isSearhingCar && "cursor-not-allowed"
                    }  hover:bg-gradient-to-t hover:from-[#b92f3f] hover:to-[#fb4156] w-full mx-auto justify-center mt-10 flex font-semibold text-mb  py-2 rounded-sm`}
                  >
                    {!searchLoading ? (
                      "BOOK A RIDE"
                    ) : (
                      <>
                        <div className="flex items-center justify-center space-x-2 test-white">
                          <div>Searching cars</div>
                          <LoadingIcon />
                        </div>
                      </>
                    )}
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>

        {/* web view end */}
        <div className="w-full h-[35rem] pt-3 bg-black sm:hidden"></div>
      </div>
    </div>
  );
};

export default BodyIntro;
